import { render } from "./RootPage.vue?vue&type=template&id=5b14af0d"
import script from "./RootPage.vue?vue&type=script&lang=js"
export * from "./RootPage.vue?vue&type=script&lang=js"

import "./RootPage.vue?vue&type=style&index=0&id=5b14af0d&lang=css"
script.render = render

export default script